import React from 'react'
import classNames from 'classnames'

interface CardProps {
  className?: string
  style?: object
  variant:
    | 'regular'
    | 'plum'
    | 'topPicks'
    | 'modal'
    | 'linkCollectionPrimary'
    | 'linkCollectionSecondary'
}

const Card: React.FC<CardProps> = ({ variant, className, style = {}, children }) => {
  return (
    <div className={classNames('Card', { [`Card__${variant}`]: variant }, className)} style={style}>
      {children}
    </div>
  )
}

export default Card
